import { Default, SM } from '@components/SummaryContent'
import React, { Component } from 'react'

import FilterDate from '@components/FilterDate'
import FilterText from '@components/FilterText'
import SelectSchoolInput from '@components/SelectSchoolInput'
import { FaFilter } from 'react-icons/fa6'
import { FiSearch } from 'react-icons/fi'
import _ from 'underscore'
import { connect } from 'react-redux'
import { fetchSummary } from '@actions/summary'
import { fetchSchools } from '@actions/school'
import { getCampaigns } from '@components/ReportFilter/options'
import lodash from 'lodash'

const ZERO_MONEY = 'R$ 0,00'

// Opção default do select de escolas: soma todas as escolas visíveis ao usuário logado.
// Vale a ausência de `school_id` na requisição — o backend então considera a escola do
// usuário + as vinculadas (role Escola) ou todas as escolas (role SM TI).
const ALL_SCHOOLS_LABEL = 'Todas'

// Estado inicial "zerado" exibido antes do usuário clicar em Filtrar (SMME26-79):
// a tela não busca dados no load; só popula depois que o usuário filtra.
const ZERO_SUMMARY = {
  total_amount: ZERO_MONEY,
  amount_teachers: ZERO_MONEY,
  retributive_amount: ZERO_MONEY,
  net_amount: ZERO_MONEY,
  retributive_amount_lij: ZERO_MONEY,
  retributive_amount_didact: ZERO_MONEY,
  retributive_amount_edu: ZERO_MONEY,
  retributive_amount_bil: ZERO_MONEY,
  retributive_amount_ere: ZERO_MONEY,
  retributive_amount_dig: ZERO_MONEY,
  retributive_amount_ser: ZERO_MONEY,
  total_students: 0,
  total_students_paid: 0,
}

class Summary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      schools: [],
      // school_id null = "Todas", opção pré-selecionada ao carregar a tela.
      school_id: null,
      date_start: null,
      date_end: null,
      filterValue: ALL_SCHOOLS_LABEL,
      filtered: false,
      loading: false,
    }
    this._onChangeDate = this._onChangeDate.bind(this)
    this._onChangeSchool = this._onChangeSchool.bind(this)
    this._updateFilterValue = this._updateFilterValue.bind(this)
    this._onFilter = this._onFilter.bind(this)
  }

  _getActiveCampaign() {
    return getCampaigns().then(campaigns => lodash.find(campaigns, { active: 1 }))
  }

  // Handlers de filtro apenas atualizam o estado local — NÃO disparam fetch.
  _onChangeDate(date) {
    this.setState({ ...date })
  }

  _lazyLoadData = _.debounce(school => {
    const selectedSchool = this.props.schools.find(item => item.value == school.school_id)

    this.setState({
      filterValue: selectedSchool?.label ?? '',
    })
  }, 1000)

  _handleSicSearch(school) {
    // Limpar o campo do SIC volta para "Todas", o mesmo estado do carregamento da tela.
    if (!school.school_id) {
      this._lazyLoadData.cancel()
      this.setState({
        school_id: null,
        filterValue: ALL_SCHOOLS_LABEL,
      })
      return
    }

    this._lazyLoadData(school)
    this.setState({
      school_id: school.school_id,
    })
  }

  _onChangeSchool(schoolId) {
    this.setState({
      school_id: schoolId,
    })
  }

  _updateFilterValue(value) {
    this.setState({
      filterValue: value,
    })
  }

  // Única origem de fetch: o clique no botão Filtrar.
  _onFilter() {
    const data = {
      // Sem escola selecionada ("Todas"), o school_id é omitido e o backend soma
      // todas as escolas disponíveis ao usuário.
      school_id: this.state.school_id || null,
      date_start: this.state.date_start,
      date_end: this.state.date_end,
    }

    this.setState({ filtered: true, loading: true })
    this.props.fetchSummary(this.props.user.id, data)
  }

  componentDidMount() {
    _.isEmpty(this.props.schools) && this.props.fetchSchools()
    // Só resolve a campanha ativa; NÃO busca o summary no load (tela abre zerada).
    this._getActiveCampaign()
  }

  componentDidUpdate(prevProps) {
    // O reducer devolve um novo objeto a cada FETCH_SUMMARY; ao mudar a referência,
    // a resposta chegou — encerra o loading. Evita o flash de "Escola não encontrada."
    // enquanto a requisição está em voo.
    if (this.state.loading && prevProps.summary !== this.props.summary) {
      this.setState({ loading: false })
    }
  }

  renderSummary(role_id, summary) {
    if (role_id === 1) {
      return <Default summary={summary} />
    } else {
      const schools = _.isEmpty(this.props.user.schools)
        ? this.props.schools.filter(school => school.value === this.props.user.school_id)
        : this.props.schools.filter(school =>
            [this.props.user.school_id, ...this.props.user.schools].includes(school.value),
          )

      // Enquanto o usuário não filtra, mostra tudo zerado.
      const hasResult = Object.getOwnPropertyNames(summary).length > 0
      const displaySummary = this.state.filtered && hasResult ? summary : ZERO_SUMMARY
      const notFound = this.state.filtered && !this.state.loading && !hasResult

      return (
        <SM summary={displaySummary}>
          <div className="summary__filter-wrapper">
            <div className="summary__filter-field summary__filter-field--school">
              <label className="summary__filter-label" htmlFor="summary-filter-school">
                Escola
              </label>
              <div className="summary__school-input">
                <SelectSchoolInput
                  id="summary-filter-school"
                  value={this.state.filterValue}
                  setInputValue={this._updateFilterValue}
                  setState={this._onChangeSchool}
                  schools={role_id === 3 ? this.props.schools : schools}
                  allOptionLabel={ALL_SCHOOLS_LABEL}
                />
              </div>
            </div>
            <div className="summary__filter-field summary__filter-field--sic">
              <label className="summary__filter-label" htmlFor="summary-filter-sic">
                Código SIC
              </label>
              <div className="summary__sic-input">
                <FiSearch className="summary__sic-icon" aria-hidden="true" />
                <FilterText
                  id="summary-filter-sic"
                  value={this.state.school_id ?? ''}
                  field="school_id"
                  label="Pesquisar código SIC da escola"
                  customClass="summary__school-filter"
                  onChange={e => this._handleSicSearch(e)}
                />
              </div>
              {notFound && <span className="summary__error">Escola não encontrada.</span>}
            </div>
            <div className="summary__filter-field summary__filter-field--date">
              <FilterDate onChange={this._onChangeDate} />
            </div>
            <button type="button" className="summary__filter-button" onClick={this._onFilter}>
              <FaFilter aria-hidden="true" />
              Filtrar
            </button>
          </div>
        </SM>
      )
    }
  }
  render() {
    const { role, summary } = this.props
    return this.renderSummary(role.id, summary)
  }
}

const mapStateToProps = state => ({
  user: state.sessionReducer.user,
  role: _.first(state.sessionReducer.user.roles),
  summary: state.summary,
  schools: state.school.schools,
})

const mapDispatchToProps = dispatch => ({
  fetchSummary: (userId, data) => dispatch(fetchSummary(userId, data)),
  fetchSchools: () => dispatch(fetchSchools()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Summary)
